// extracted by mini-css-extract-plugin
export default {"dashboard":"app_dashboard__gCB-p","link":"app_link__5pkWv"};